<div class="flex flex-col ml-60 mr-60">
  <h2 class="mat-headline-5 mt-20 ml-10 mb-32">{{'SUBSRIPTION.SUBSCRIPTION' | transloco}}</h2>
  <div *ngIf="!isLoading; else loadingIconShows">
    <div *ngIf="!showNoSubscription" class="flex flex-col pl-10">
      <app-subscription-tenant [tenantData]="tenantDetailsData" [accountData]="subscriptionId"></app-subscription-tenant>
    </div>
  </div>
  <ng-template #loadingIconShows>
    <div class="flex flex-row justify-center items-center spinner">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </ng-template>
  <mat-card *ngIf="showNoSubscription && !isLoading" class="flex flex-col spinner-container spinner">
    <img class="mr-8 w-46 h-56 mb-16" src="/assets/images/Layer_2.png"/>
    <div>{{'SUBSRIPTION.SELECT_TENANT_FILTER' | transloco }}</div>
  </mat-card>
</div>
  
  